<div class="screen">

    <!-- HEADER -->
    <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/transfer-successful.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Transfer successful</div>
  
      <div class="subtitle">
        You transferred {{transaction.receiveCurrency}} {{transaction.receiveAmount}} to your Momo account.
      </div>
    </div>
  
    <!-- BUTTON -->

    <footer class="screen-footer">
      <button pButton label="DONE" class="edit-btn" (click)="done()"></button>  
    </footer>  
    <!--<button pButton label="VIEW DETAILS" class="confirm-btn"></button>-->
    
  </div>